import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import moment from 'moment';
import {Card, Table, Dropdown, Loader, Popup, Icon, Modal} from 'semantic-ui-react';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {dateFormatReservation} from '../../../../common/constants/datesFormat';
import {pageSizes} from '../../../../common/constants/lists';
import {Actions} from '../../../../common/actions';
import TablePaginator from '../../../../common/components/tablePaginator';

const statusDictionary = {
  'I': 'En proceso',
  'R': 'Rechazado',
  'P': 'Procesado',
};

class InternalOrderTable extends Component {
  constructor(props) {
    super(props);
    this.onPageSizeClick = this.onPageSizeClick.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
  }

  onPageClick(value) {
    this.props.changeInternalsOrdersListPage(value);
  }

  onPageSizeClick(event, data) {
    this.props.changeInternalsOrdersListPageSize(data.value);
  }

  onDeleteClick(code) {
    const returnToList = false;
    this.props.deleteInternalOrder(code, returnToList);
  }

  renderEditOption(code) {
    if (!hasAccessPermission(this.props.permissions, resources.InternalOrders, scopes.Edit)) {
      return null;
    }
    return (
      <Popup
        trigger={
          <Link to={`/pedidos-internos/editar/${code}`}>
            <Icon name='write' size='large' />
          </Link>
        }
        content='Editar'
        position='top center'
        inverted
      />
    );
  }

  renderDeleteOption(code) {
    if (!hasAccessPermission(this.props.permissions, resources.InternalOrders, scopes.Delete)) {
      return null;
    }
    return (
      <Modal size={'mini'}
        trigger={
          <span className='link'>
            <Popup
              trigger={
                <span>
                  <Icon link name='delete' color='blue' size='large' />
                </span>
              }
              content="Eliminar"
              position='top center'
              inverted
            />
          </span>
        }
        header='¿Está seguro que desea eliminar el pedido seleccionado?'
        actions={[
          {'key': 'cancel', 'content': 'Cancelar'},
          {'key': 'done', 'content': 'Confirmar', 'positive': true,
            'onClick': () => this.onDeleteClick(code),
            'primary': true,
          },
        ]}
      />
    );
  }

  renderPagination() {
    const {pageNumber, pageSize, totalItems} = this.props;

    if (totalItems <= pageSize) {
      return null;
    }
    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'>
                <strong>Items por página</strong>
                <Dropdown
                  selection
                  upward
                  compact
                  value={pageSize}
                  options={pageSizes}
                  onChange={this.onPageSizeClick}
                />
              </span>
              <TablePaginator
                itemsCount={totalItems}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick}
              />
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  
  renderInternalsOrders() {
    const {internalsOrdersList} = this.props;
    if (!internalsOrdersList.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={6}>No hay Pedidos Internos</Table.Cell>
        </Table.Row>
      );
    }
    return internalsOrdersList.map((element, index) => {
      const dateFormatted = moment(element.date).format(dateFormatReservation);
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.clientName}</Table.Cell>
          <Table.Cell textAlign='center'>{element.code}</Table.Cell>
          <Table.Cell textAlign='center'>{dateFormatted.toUpperCase()}</Table.Cell>
          <Table.Cell textAlign='center'>{element.user}</Table.Cell>
          <Table.Cell textAlign='center'>{statusDictionary[element.status]}</Table.Cell>
          <Table.Cell textAlign='center'>
            {this.renderEditOption(element.code)}
            {this.renderDeleteOption(element.code)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  renderLoaderOrInternalsOrders() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderInternalsOrders();
  }

  render() {
    const {showData} = this.props;

    if (!showData) {
      return null;
    }

    return (
      <Card fluid raised>
        <Table striped className='toyota-grid'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell textAlign='center'>Cliente</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'># Pedido</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Fecha de Pedido</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Pedido por</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Estado</Table.HeaderCell>
              <Table.HeaderCell textAlign='center'>Acciones</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
      
          <Table.Body>
            {this.renderLoaderOrInternalsOrders()}
          </Table.Body>

          {this.renderPagination()}
        </Table>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.internalOrder.loading,
    'internalsOrdersList': state.internalOrder.internalsOrdersListByPage,
    'totalItems': state.internalOrder.internalsOrdersList.length,
    'pageNumber': state.internalOrder.pageNumber,
    'pageSize': state.internalOrder.pageSize,
    'permissions': state.session.permissions,
  };
};

const {
  changeInternalsOrdersListPage,
  changeInternalsOrdersListPageSize,
  deleteInternalOrder,
} = Actions;

export default connect(mapStateToProps, {
  changeInternalsOrdersListPage,
  changeInternalsOrdersListPageSize,
  deleteInternalOrder,
})(InternalOrderTable);
